import { render } from "./profile3.vue?vue&type=template&id=be840b90"
import script from "./profile3.vue?vue&type=script&lang=js"
export * from "./profile3.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__